import EventDispatcher from "@/events/EventDispatcher";
import AppEvent from "@/events/AppEvent";
import { Sweep } from "@/params/Sweep";
import { Howl, Howler } from "howler";

export default class BGMSound extends EventDispatcher {
  public audio: HTMLAudioElement;
  public bgmSound: Howl;
  public isLoaded: boolean = false;
  public label: string = '';
  public type: string = '';
  public sweep: Sweep;
  
  protected basisVolume: number = 1;
  protected limitDistance: number = 30;
  protected attenuate: number = 1;
  protected _volume: number = 1;
  protected _distance: number = 1;
  protected _elevation: number = 0;
  
  
  constructor (type: string, label: string, src: string, sweep: Sweep, basisVolume: number = 1, limitDistance: number = 30, attenuate: number = 1) {
    super();
    this.type = type;
    this.label = label;
    // this.audio = new Audio(src);
    this.bgmSound = new Howl({
      src: [src],
      loop: true,
      preload: false
    });
    this.sweep = sweep;
    this.basisVolume = basisVolume;
    this.limitDistance = limitDistance;
    this.attenuate = attenuate;
  }
  
  
  public load(): void {
    /*
    this.audio.load();
    if (this.audio.readyState === 4) {
      this.isLoaded = true;
      this.dispatchEvent(AppEvent.LOAD_COMPLETE);
    }
    else {
      this.audio.addEventListener('canplaythrough',this.onLoadComplete);
    }
     */
    this.bgmSound.once('load', () => {
      console.log('BGM - ' + this.label + ' is Loaded');
      this.isLoaded = true;
      this.dispatchEvent(AppEvent.LOAD_COMPLETE);
    });
    this.bgmSound.load();
  };
  
  
  protected onLoadComplete = (ev: Event): void => {
    // console.log('Audio Complete: ' + this.label);
    /*
    this.audio.removeEventListener('canplaythrough', this.onLoadComplete);
    this.isLoaded = true;
    this.dispatchEvent(AppEvent.LOAD_COMPLETE);
     */
  };
  
  /**
   * ボリュームを設定する(0〜1.0)
   * @param value
   */
  set volume (value: number) {
    this._volume = value;
    this.setComputedVolume();
  }
  get volume (): number { return this._volume; }
  
  /*
  set distance (value: number) {
    this._distance = value;
    this.setComputedVolume();
  }
  get distance (): number { return this._distance; }
  */
  
  public setDistance (distance: number, elevation: number): void {
    this._distance = distance;
    this._elevation = elevation;
    this.setComputedVolume();
  }
  
  
  protected setComputedVolume () {
    if (this._distance <= this.limitDistance) {
      // 平面差における音量の減衰を加える
      let k: number = this._distance < 1 ? 1 : this._distance * this.attenuate;
      k = k < 1 ? 1 : k;
      // console.log('減衰：' + k);
      let computedVol: number = this.basisVolume * this._volume / k;
      // 高低差における音量の減衰を加える
      computedVol = this._elevation >= 1 ? computedVol / (this._elevation * 1.5) : computedVol;
      // 音量をセットする
      // this.audio.volume = computedVol;
      this.bgmSound.volume(computedVol);
      // console.log('音量：' + computedVol);
    }
    else {
      this.bgmSound.volume(0);
      // this.audio.volume = 0;
    }
  }
  
  
  play = (): void => {
    /*
    this.audio.loop = true;
    this.audio.play();
     */
    this.bgmSound.play();
  };
  
  pause = (): void => {
    // this.audio.pause();
    this.bgmSound.pause();
  };
  
  stop = (): void => {
    // this.audio.pause();
    // this.audio.currentTime = 0;
    this.bgmSound.stop();
  };
  
  mute = (): void => {
    // this.audio.volume = 0;
    this.bgmSound.mute(true);
  };
  
  clearMute = (): void => {
    // this.audio.volume = this.basisVolume * this._volume;
    this.bgmSound.mute(false);
  };
  
}
